import React from "react";

import { AssociateContentEmbeddedForm } from "../../../../common/content/forms/AssociateContentEmbeddedForm";
import { useCreateFileRecordAssociateContentForm } from "./useCreateFileRecordAssociateContentForm";

export const CreateFileRecordAssociateContentForm: React.FC = () => {
    const {
        defaultContentState,
        isDefaultContentLoading,
        validation,
        form
    } = useCreateFileRecordAssociateContentForm();

    return (
        <AssociateContentEmbeddedForm
            form={form}
            defaultContentState={defaultContentState}
            isDefaultContentLoading={isDefaultContentLoading}
            validation={validation}
            style={{ minHeight: "80vh" }}
        />
    );
};
